import voters from './voters';

export default {
  voters,
};
